var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 250,
    width: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 300,
    height: 200,
    rx: 20,
    ry: 20,
    fill: "whitesmoke",
    filter: "url(#blur)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare2);
export default __webpack_public_path__ + "static/media/square2.3031985e45b8bcef7cd45f234a45d4ce.svg";
export { ForwardRef as ReactComponent };